import $ from 'jquery'
// import React from 'react-dom';
// import ReactDOM from 'react-dom';
import moment from 'moment'
import config from '../store/_config'
import _ from 'lodash'
import { axiosInstance as axios, handleAxiosErrors, breakListIntoChunks, floorToTwoDecimals } from '_utils'
import {
  toggleCocktailLoading,
  convertCocktailsListToAReadableFormat,
  convertCocktailToAReadableFormat,
} from '../actions/cocktailsActions'
import {
  combineProductIDsWithCartQuantity,
  hasFiltersSelected,
  getProductsFullInfo,
} from '../selectors/defaultSelectors'
import { createAlert } from '../../main/dom/window'
import { segmentTrackProductViewed } from '../utils/segment/ecommerce'
import { setUserCredentials, setDiscountSyncing } from '../actions/userActions'
import { updateCartItemProduct } from './cartActions'
import { updateCartList } from './cartSupplierActions'
import { setPromoDealsSync } from './dealBuilderActions'
import Numeral from 'numeral'
import { handleProductResponse, updateProductsList, requestProductsNotification } from './productsActions'
import { getProductURL } from '../selectors/productSelectors'

export const toggleDealBuilderLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_DEAL_BUILDER_LOADING',
      value: value,
    })
  }
}

export const toggleDealBuilderListLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_DEAL_BUILDER_LIST_LOADING',
      value: value,
    })
  }
}

export const toggleDealBuilderListAvailable = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_DEAL_BUILDER_AVAILABLE',
      value: value,
    })
  }
}

export const setDealBuilder = (list) => {
  return {
    type: 'SET_DEAL_BUILDER',
    list: list,
  }
}

export const setDealBuilderProductID = (product_id) => {
  return {
    type: 'SET_DEAL_BUILDER_PRODUCT_ID',
    product_id: product_id,
  }
}

export const isInDeal = (internalItemID, store) => {
  const { user } = store
  // const customerPromo = user?.customerPromo
  const promoDeals = user?.promoDeals
  const customerPromo = typeof store.user?.customerPromo != 'undefined' ? store.user.customerPromo : {}

  if (customerPromo[internalItemID] && customerPromo[internalItemID]['Featured']) {
    return true
  }
  if (
    _.some(promoDeals, function (go) {
      return go === internalItemID
    })
  ) {
    return true
  }

  return false
}

export const requestDealProductsByInternalItemID = (promoDeals) => {
  // debugger
  return (dispatch, getState) => {
    const store = getState()

    if (store.dealBuilder.loadPromoDetails == 1) {
      return
    }
    dispatch(toggleDealBuilderLoading(true))
    // dispatch(toggleDealBuilderLoading(true))
    // dispatch(setPromoDealsSync(1))

    // if (Object.keys(promoDeals).length === 0) {
    //     dispatch(toggleDealBuilderLoading(false))
    //     return
    // }

    let dealProductIDS = []
    promoDeals.map((promoDeal) => {
      dealProductIDS = _.uniq([...dealProductIDS, ...Object.values(promoDeal.Products)])
    })

    /**
     * Incase when product has only featured discount available
     */
    if (dealProductIDS.length == 0) {
      dispatch(setDealBuilder([]))
      dispatch(requestProductDeals([]))
    }

    let promisedRequests = []

    const chunkedList = breakListIntoChunks(dealProductIDS, 100)

    chunkedList.map((chunkedProductIDs) => {
      promisedRequests.push(
        dispatch(
          requestDealsProductsByIDs({ products: chunkedProductIDs }, (products) => {
            let _products = []

            products.map((product) => {
              if (promoDeals[product.sku]) {
                product.tooltip = 'Click to view deal'
              }
              _products.push(product)
            })

            // dispatch(updateOrderTemplate(_products))
            dispatch(updateProductsList(_products))
            dispatch(updateCartList(_products))
            dispatch(toggleDealBuilderLoading(false))
            dispatch(setDealBuilder(promoDeals))
            dispatch(requestProductDeals(promoDeals))
            dispatch(requestProductsNotification(_.map(_products, 'id')))
            dispatch(toggleDealBuilderListLoading(false))
          })
        )
      )
    })
  }
}

export const checkIfDealAvailable = () => {
  return (dispatch, getState) => {
    dispatch(toggleDealBuilderListAvailable(true))
  }
}

export const requestProductDeals = (dealMap = null) => {
  return (dispatch, getState) => {
    const store = getState()
    const promos = store.user.promoDeals

    const customerPromo = store.user.customerPromo

    const products = store.products.list
    const selectedProductID = store.dealBuilder.product_id
    if (!dealMap) {
      dealMap = store.dealBuilder.list || []
    }

    if (!_.isArray(dealMap)) {
      dealMap = []
    }

    dealMap?.forEach((dealItem) => {
      if (dealItem.Products && dealItem.Products.length > 0) {
        dealItem.Products.map((dealItemProduct) => {
          Object.keys(products).forEach((productID) => {
            if (products[productID]?.sku == dealItemProduct) {
              if (!dealItem.FinalProduct) {
                dealItem.FinalProduct = []
              }

              dealItem.FinalProduct.push(products[productID])
            }
          })
        })

        dealItem.FinalProduct = _.keyBy(dealItem.FinalProduct, 'id')

        dealItem.FinalProduct = _.values(getProductsFullInfo(dealItem.FinalProduct, store))
      }

      if (dealItem.FeaturedPromotion === 'Bonus Deal') {
        dealItem.FeaturedTitle = 'Deal: ' + dealItem.FeaturedPromotion

        const allProducts = _.values(products || {})

        const bonusProduct = _.find(
          allProducts,
          (product) => product?.sku?.toString() === dealItem?.FreeProductID?.toString()
        )

        let productLink = dealItem.FreeBonusName
        if (bonusProduct?.url_slug) {
          productLink = `<a  href="/product/${bonusProduct.url_slug}">${dealItem.FreeBonusName}</a>`
        }

        dealItem.FeaturedDescription =
          'Buy any ' +
          dealItem.MinPurchase +
          ((' ' + dealItem?.BonusDiscountType || 'case') + '(s)') +
          ' of the following, Receive ' +
          dealItem.FreeUnits +
          (' ' + dealItem?.BonusDiscountType || 'case') +
          '(s) free of ' +
          productLink

        dealItem.FeaturedSubDescription = dealItem.WebDescription || ''
      }

      // if (dealItem.FeaturedPromotion === 'Bonus Deal') {
      //   dealItem.FeaturedTitle = 'Deal: ' + dealItem.FeaturedPromotion
      //   dealItem.FeaturedDescription =
      //     'Buy any ' +
      //     dealItem.MinPurchase +
      //     ((' ' + dealItem?.BonusDiscountType || 'case') + '(s)') +
      //     ' of the following, Receive ' +
      //     dealItem.FreeUnits +
      //     (' ' + dealItem?.BonusDiscountType || 'case') +
      //     '(s) free of ' +
      //     dealItem.FreeBonusName
      //   dealItem.FeaturedSubDescription = dealItem.WebDescription || ''
      // }
      if (dealItem.FeaturedPromotion === 'Quantity Buy $ Off') {
        dealItem.FeaturedTitle = 'Deal: ' + dealItem.FeaturedPromotion
        dealItem.FeaturedDescription =
          'Buy any  ' +
          dealItem.MinPurchase +
          ' of the following, Receive ' +
          Numeral(dealItem.QuantityValueOff).format('$0,0.00') +
          ' off '
        dealItem.FeaturedSubDescription = dealItem.WebDescription || ''
      }
      if (dealItem.FeaturedPromotion === 'Quantity Buy % Off') {
        dealItem.FeaturedTitle = 'Deal: ' + dealItem.FeaturedPromotion
        dealItem.FeaturedDescription =
          'Buy any  ' +
          dealItem.MinPurchase +
          ' of the following, Receive ' +
          parseFloat(dealItem.QuantityPercentOff) * 100 +
          '% off '
        dealItem.FeaturedSubDescription = dealItem.WebDescription || ''
      }

      // if(dealItem.PromotionID!==null || dealItem.PromotionID!==undefined)
      // {
      //   dealItem.PromotionID='Promotion ID: '+dealItem.PromotionID;
      // }
    })

    /**
     * Insert Featured Promotion Object here, fetch from Customer Discounts where Featured = 1
     */
    if (customerPromo[selectedProductID] && customerPromo[selectedProductID]?.Featured) {
      let discount = customerPromo[selectedProductID]
      let dealObj = {
        id: selectedProductID,
        dealid: selectedProductID,
        FeaturedTitle:
          'Deal: ' +
          (discount.WebDescription != 'null' && discount.WebDescription != null && discount.WebDescription != ''
            ? discount.WebDescription
            : 'Featured Promotion'),
        FeaturedSubDescription: discount.WebDescription || '',
        productTitle: '',
        Sort: 4,
        FeaturedDescription: '',
        Products: [],
      }

      Object.keys(products).forEach((product) => {
        if (products[product]?.sku == selectedProductID) {
          dealObj.Products.push({ id: products[product].id })
        }
      })

      dealObj.Products = _.keyBy(dealObj.Products, 'id')

      dealObj.FinalProduct = _.values(getProductsFullInfo(dealObj.Products, store))
      dealObj.PromotionID = dealMap.PromotionID

      if (dealObj.FinalProduct && dealObj.FinalProduct.length > 0 && dealObj.FinalProduct[0]?.case_discount) {
        let bonusProduct =
          dealObj.FinalProduct[0]?.title +
          (dealObj.FinalProduct[0]?.splitPackSize ? ' (' + dealObj.FinalProduct[0]?.splitPackSize + ' Pack' + ')' : '')

        dealObj.FeaturedDescription =
          'Buy ' +
          bonusProduct +
          ', Receive ' +
          Numeral(dealObj.FinalProduct[0]?.case_discount).format('$0,0.00') +
          '  off '
      }
      _.remove(dealMap, (o) => {
        return o.id === dealObj.id
      })
      dealMap.push(dealObj)

      if (dealMap.length > 0) {
        dispatch(toggleDealBuilderListLoading(false))
      }
    }
    dispatch(
      setDealBuilder(
        _.orderBy(
          dealMap,
          (o) => {
            return o.Sort
          },
          ['asc']
        )
      )
    )
  }
}

export const axiosRequestDealsForProductSku = (params) => {
  return (dispatch, getState) => {
    let { url, query } = config.promoDeals.getDealsforProductSku

    return axios
      .post(url, {
        withCredentials: true,
        variables: {
          InternalItemID: params.internalItemID,
        },
        query: query,
      })
      .then((response) => {
        const deals = JSON.parse(response.data.data.readProductPromoDeals.PromoDeals)
        dispatch(setDealBuilderProductID(params.internalItemID))

        dispatch(requestDealProductsByInternalItemID(deals))
        // dispatch(toggleDealBuilderListLoading(false))
      })
      .catch((error) => handleAxiosErrors(error))
  }
}

export const fetchProductDealsFromServer = (internalItemID) => {
  return (dispatch, getState) => {
    console.log('request deal from server')
    const store = getState()

    dispatch(toggleDealBuilderLoading(true))
    dispatch(toggleDealBuilderListLoading(true))
    dispatch(axiosRequestDealsForProductSku({ internalItemID: internalItemID }))

    dispatch(setDealBuilderProductID(internalItemID))
  }
}

export const requestDealsProductsByIDs = (params = {}, callback) => {
  return (dispatch, getState) => {
    const state = getState()

    let { url, query } = config.products.prductDetails
    return axios
      .post(
        url,
        {
          query: query,
          variables: {
            InternalItemIDs: params.products.map((ID) => Number(ID)),
          },
        },
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        handleProductResponse(dispatch, state, params, response, callback)
      })
      .then(() => {
        console.log('in my update')
        dispatch(requestProductDeals())
      })
      .catch((error) => handleAxiosErrors(error))
  }
}
